<template>
  <div>
    <div style="margin-bottom: 10px">考级须知</div>
    <div style="max-height: 400px;overflow-y: auto;overflow-x: hidden;border: solid 1px #e6e6e6;padding: 20px">
      <el-form :model="environmentForm" ref="environmentForm">
        <el-form-item>
          <el-row :gutter="10" v-for="(item, index) in environmentForm.items" :key="index">
            <el-form-item style="display: inline-block;width: 80%;margin: 10px 0" :rules="[$validate.fileName(100)]" :prop="'items.' + index + '.notice'">
              <el-input type="textarea" :rows="2" show-word-limit maxlength="100" v-model="item.notice"></el-input>
            </el-form-item>
            <el-col :span="2" v-if="environmentForm.items.length != 1" style="float: right;margin-top: 5px;">
              <i @click="removeEnvironmentForm(item)" style="font-size:30px;cursor:pointer;" class="icon icon_minus-circle"></i>
            </el-col>
            <el-col :span="2" style="float: right;margin-top: 5px;">
              <i @click="addEnvironmentForm" style="font-size: 30px;cursor:pointer;" class="icon icon_add-circle"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="text-right" style="margin-top: 10px;">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'specialty-attrbute-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      environmentForm: {
        items: [{
          notice: ''
        }]
      }
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  methods: {
    //移除表单项事件
    removeEnvironmentForm (item) {
      let index = this.environmentForm.items.indexOf(item)
      if (index !== -1) {
        this.environmentForm.items.splice(index, 1)
      }
      this.$forceUpdate()
    },
    //添加表单项事件
    addEnvironmentForm () {
      if (this.environmentForm.items.length <= 9) {
        this.$nextTick(() => {
          this.environmentForm.items.push({
            notice: ''
          });
        })
      } else {
        this.$message({ type: 'error', message: '最多添加十条' })
      }
      this.$forceUpdate()
    },
    async initForm () {
      if (this.row && this.row.examineeNotice != null) {
        this.environmentForm = this.row
        let arrayData = this.environmentForm.examineeNotice.split('#')
        const arrayList = arrayData.map(item => {
          return {
            notice: item
          }
        })
        this.$set(this.environmentForm, 'items', arrayList)
      }
    },
    async save () {
      try {
        let isOK = await this.Tool.checkForm(this.$refs['environmentForm'])
        if (isOK) {
          this.environmentForm.batchId = this.row.batchId
          this.environmentForm.specialtyId = this.row.specialtyId
          const list = this.environmentForm.items.map(el => el.notice)
          this.environmentForm.examineeNotice = list.join("#")
          let queryParam = {
            specialtyId: this.environmentForm.specialtyId,
            examineeNotice: this.environmentForm.examineeNotice
          }
          await this.$HTTP.ApiSpecialty.edit(queryParam)
          this.$message({ type: 'success', message: '操作成功' })
          this.$emit('close', this.form)
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
<style>
  .el-textarea .el-input__count {
    bottom: -11px;
    right: 20px;
    background: transparent;
  }
</style>
